// jQuery を最初にインポートしてグローバルに設定
import $ from "./jquery-global.js";

// jQuery プラグインは jQuery がグローバルに設定された後にインポート
import "jquery-validation";
import "jquery.cookie";
import "jscroll";
import "form-serializer";
import "jqtree";

import select2Factory from "select2/dist/js/select2.full.js";
const select2Target = typeof window !== "undefined" ? window : globalThis;
select2Factory(select2Target, $);

// CSS
import "modern-css-reset/dist/reset.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "select2/dist/css/select2.css";
import "jqtree/jqtree.css";

import * as d3 from "d3";
window.d3 = d3;

import BigNumber from "bignumber.js";
window.BigNumber = BigNumber;

import md5 from "md5";
window.MD5 = md5;

import { ulid } from "ulid";
window.ulid = ulid;

import {browserSupportsWebAuthn, startAuthentication, startRegistration} from "@simplewebauthn/browser";
window.SimpleWebAuthnBrowser = {
	browserSupportsWebAuthn,
	startAuthentication,
	startRegistration,
};
